module.exports = __webpack_public_path__ + "static/media/thumb.a06b8e7e.svg";